<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Quote Transfer"
      ><i class="las la-exchange-alt text-primary fs-1100"></i
    ></a>

    <b-modal ref="modal" hide-footer title="Quote Transfer">
      <div class="d-block">
        <WDMessage :message="message"></WDMessage>
        <dl class="row">
          <dt class="col-sm-4">Quote Id</dt>
          <dd class="col-sm-8">{{ rowData.id }}</dd>
          <dt class="col-sm-4">Dealer</dt>
          <dd class="col-sm-8">{{ rowData.dealer }}</dd>
          <dt class="col-sm-4">Business manager</dt>
          <dd class="col-sm-8">
            <span v-if="isDealer">{{ rowData.createdBy }}</span>
            <span v-if="isVsaStaff"
              >{{ rowData.dealer_user }}
              {{ rowData.dealer_user_last_name }}</span
            >
          </dd>
          <dt class="col-sm-4">Client name</dt>
          <dd class="col-sm-8">{{ rowData.client }}</dd>
          <dt class="col-sm-4">Current status</dt>
          <dd class="col-sm-8">
            <WDQuoteStatusBadge :status="rowData.status"></WDQuoteStatusBadge>
          </dd>
        </dl>

        <hr />
        <dl class="row" v-if="isVsaStaff">
          <dt class="col-sm-4">Select Dealer</dt>
          <dd class="col-sm-8">
            <div
              class="form-group"
              v-if="getDealerDropdown && getDealerDropdown.length > 0"
            >
              <multiselect
                v-model="dealerObj"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a dealer"
                track-by="id"
                label="name"
                :options="getDealerDropdown"
                :taggable="true"
                :allow-empty="false"
              >
              </multiselect>
            </div>
          </dd>
        </dl>

        <dl class="row" v-if="isDealer">
          <dt class="col-sm-4">Select Dealer</dt>
          <dd class="col-sm-8">
            <div
              class="form-group"
              v-if="
                getDealersWhichBelongsToUser &&
                getDealersWhichBelongsToUser.length > 0
              "
            >
              <multiselect
                v-model="dealerObj"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a dealer"
                track-by="id"
                label="name"
                :options="getDealersWhichBelongsToUser"
                :taggable="true"
                :allow-empty="false"
              >
              </multiselect>
            </div>
          </dd>
        </dl>

        <dl
          class="row"
          v-if="
            Object.keys(dealerObj).length &&
            getDealerStaffDropdown.length &&
            isVsaStaff
          "
        >
          <dt class="col-sm-4">Select User</dt>
          <dd class="col-sm-8">
            <div class="form-group">
              <multiselect
                v-model="dealerUserObj"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a user"
                track-by="id"
                :options="getDealerStaffDropdown"
                label="name"
                :taggable="true"
                :allow-empty="false"
              >
              </multiselect>
            </div>
          </dd>
        </dl>

        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-secondary btn-sm mr-2"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            type="button"
            @click="fnUpdate()"
            class="btn btn-success btn-sm"
          >
            Update
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../services/auth.service'
import * as messageService from '../../services/message.service'
import * as quoteService from '../../services/quote.service'
import datePicker from 'vue2-datepicker'
import WDQuoteStatusBadge from '../../components/wd/WDQuoteStatusBadge.vue'
import WDMessage from '../../components/wd/WDMessage.vue'
export default {
  name: 'ModalQuoteTransfer',
  props: ['rowData'],
  components: {
    datePicker,
    WDQuoteStatusBadge,
    WDMessage
  },
  data() {
    return {
      errors: {},
      dealerObj: {},
      dealerUserObj: {},
      loginUserObj: {},
      userByIdObj: {},

      getUsersDropdown: [],
      message:
        'After Quote Transfer you may need to check quote <strong class="text-danger">Options</strong> <br>Eg. Compete | Brokerage | Set Manual Budgets'
    }
  },
  computed: {
    ...mapGetters([
      'getAdminQuotePaginate',
      'getDealerDropdown',
      'getDealerStaffDropdown',
      'getUserById',
      'getQuotePaginate',
      'getQuotePaginateData'
    ]),
    getDealersWhichBelongsToUser() {
      /**
       * if user in dealer action might require
       */
      let arr = this.getUserById.dealers

      if (arr == undefined) {
        return
      }

      return arr
    },
    /**
     * Only Dealers
     */
    isDealer() {
      const { role_id } = this.loginUserObj
      if (role_id == '4') {
        return true
      }

      return false
    },
    /**
     * All VSA Staff
     */
    isVsaStaff() {
      const { role_id } = this.loginUserObj
      if (role_id == '1' || role_id == '2' || role_id == '3') {
        return true
      }

      return false
    },
    /**
     * All VSA Staff
     */
    isBDM() {
      const { role_id } = this.loginUserObj
      if (role_id == '3') {
        return true
      }

      return false
    }
  },
  methods: {
    ...mapActions([
      'fetchAdminQuotePaginate',
      'fetchDealerDropdown',
      'fetchDealerStaffDropdown',
      'fetchUserById',
      'fetchQuotePaginate'
    ]),
    fnShowModal: async function () {
      this.loginUserObj = await authService.getUserFromToken()
      this.fetchUserById(this.loginUserObj.id)
      this.showModal()
    },
    hideModal() {
      this.dealerObj = {}
      this.dealerUserObj = {}
      this.$refs.modal.hide()
    },
    showModal() {
      this.fetchDealerDropdown()
      this.$refs.modal.show()
    },

    fnUpdate: async function () {
      const obj = {
        dealerId: this.dealerObj.id,
        createdBy: this.dealerUserObj.id
      }

      try {
        this.errors = {}
        const response = await quoteService.transferDealer(this.rowData.id, obj)
        const { status_code } = response.data

        if (status_code == 200) {
          const { role_id } = this.loginUserObj
          if (role_id == 3 || role_id == 4) {
            this.fetchQuotePaginate(this.getQuotePaginate)
          }

          if (role_id == 1 || role_id == 2) {
            this.fetchAdminQuotePaginate(this.getAdminQuotePaginate)
          }

          messageService.fnSweetAlertSuccessToast(
            'Quote status',
            'Updated successfully '
          )

          this.hideModal()
        }

        messageService.fnSweetAlertSuccessToast(
          'Quote',
          'Transferred successfully '
        )

        this.hideModal()
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Quote transferred ',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Quote transferred ',
              'Something wrong'
            )
            break
        }
        console.log('fnUpdate - something wrong', error)
      }
    }
  },
  watch: {
    dealerObj(newVal) {
      this.fetchDealerStaffDropdown(newVal.id)
    }
  }
}
</script>
